<template>
  <v-card height="auto">
    <vue-card-title
      title="View Department and Teams"
      subtitle="Here you can see the detail view of Department and Teams."
      :icon="$getIcon('mdiEyeOutline')"
      closable
      dark
      @close="$emit('close')"
    ></vue-card-title>
    <v-card-text class="py-4 scrollbar-md">
      <div v-if="actionData.slug">
        <v-row>
          <v-col v-for="(item, index) in details" :key="index" md="4" cols="12">
            <v-row no-gutters>
              <v-col cols="12">
                <v-icon v-text="$getIcon('mdiInformationOutline')"></v-icon>
                {{ item.name }}
              </v-col>
              <v-col cols="12" class="pl-7 black--text">
                <div v-if="item.name === 'Head'">
                  <v-row v-if="item.value" align="center" no-gutters>
                    <v-avatar :size="25">
                      <v-img
                        :src="
                          item.value.profile_picture ||
                            require(`@/static/images/info/user-default.png`)
                        "
                        alt="User picture"
                      ></v-img>
                    </v-avatar>
                    <v-col class="text-left ml-2">
                      <div>
                        {{ item.value.name }}
                      </div>
                    </v-col>
                  </v-row>
                  <div v-else>N/A</div>
                </div>
                <div v-else-if="item.name === 'Members'">
                  <crm-user-thumbnails
                    :users="item.value"
                    :limit="3"
                    :size="25"
                    thumbnail-info="Assigned Members"
                    class="my-1"
                  ></crm-user-thumbnails>
                </div>
                <div v-else>{{ item.value || "N/A" }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <vue-no-data v-else></vue-no-data>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn text @click="$emit('close')" class="text-capitalize">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import CrmUserThumbnails from "@/components/crm/layout_utils/CrmUserThumbnailsNew";

export default {
  components: {
    CrmUserThumbnails
  },
  props: {
    actionData: {
      type: [Object, Array],
      required: true
    }
  },
  data() {
    return {
      details: [
        {
          name: "Name",
          value: this.actionData.name
        },
        {
          name: "Email",
          value: this.actionData.email || "N/A"
        },
        {
          name: "Parent",
          value:
            (this.actionData.parent && this.actionData.parent.name) || "N/A"
        },
        {
          name: "Head",
          value: this.actionData.head
        },
        {
          name: "Extension Number",
          value: this.actionData.extension_number
        },
        {
          name: "Is Archived",
          value: this.actionData.is_archived ? "True" : "False"
        },
        {
          name: "Members",
          value: this.actionData.members
        },
        {
          name: "Service Categories",
          value:
            this.actionData.service_categories &&
            this.actionData.service_categories.map(x => x.name).toString()
        },
        {
          name: "Description",
          value: this.actionData.description
        }
      ]
    };
  }
};
</script>
